module.exports = new __parcel__URL__("ghost-eaten.21e1a3e5.mp3").toString();